import { $framework, useTranslation } from "@opendash/core";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { TicketSaveModal } from "../..";
import { OpenService } from "../../../../types/config";

type Props = {};

/**
 * Is registered as a global component in the open dash app.
 * This component listens to the command `ticket.create` and opens the ticket creation modal.
 */
export const GlobalTicketModal = observer((props: Props) => {
  const t = useTranslation(); // uses the translation prefix of the core. so the translations are saved in the core translation files.
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    $framework.commands.registerCommand({
      id: "openservice",
      title: t("opendash:command.plugin.title"),
      description: t("opendash:command.plugin.description"),
      permission: OpenService.Permissions.Access.global,
      shortcut: ["o"],
    });

    $framework.commands.registerCommand({
      id: "openservice:ticket.create",
      title: t("opendash:command.ticket.create.title"),
      description: t("opendash:command.ticket.create.description"),
      permission: OpenService.Permissions.Create.ticket,
      shortcut: ["t"],
      handler: () => {
        setOpen(true);
      },
      parent: "openservice",
    });
  }, []);

  return (
    <TicketSaveModal
      open={open}
      onClose={() => setOpen(false)}
      onSaveSuccess={() => setOpen(false)}
    />
  );
});
